import SuitesEvents from '../../containers/Event'
import Layout from '../../components/Layout'

import React from 'react'
import { connect } from 'react-redux'

export const Events = ({ history, location }) => {
  return (
    <Layout isSidebar={true} title='Events'>
      <SuitesEvents history={history} location={location} />
    </Layout>
  )
}

export default connect(null, null)(Events)
